import HistoriqueController from './historique.controller';

export default {
    template: require('./historique.tpl.html'),
    controller: HistoriqueController
};
